import { ADD_PAY_CUSTOMER_PAYMENT_NOTE_LINE_REQUEST, ADD_PAY_CUSTOMER_PAYMENT_NOTE_LINE_SUCCESS, ADD_PAY_CUSTOMER_PAYMENT_NOTE_LINE_ERROR, GET_ONE_PAY_CUSTOMER_PAYMENT_NOTE_LINE_ERROR, GET_ONE_PAY_CUSTOMER_PAYMENT_NOTE_LINE_SUCCESS, GET_ONE_PAY_CUSTOMER_PAYMENT_NOTE_LINE_REQUEST, GET_CUSTOMER_PAYMENT_DETAIL_REQUEST, GET_CUSTOMER_PAYMENT_DETAIL_SUCCESS, GET_CUSTOMER_PAYMENT_DETAIL_ERROR, UPDATE_PAY_CUSTOMER_PAYMENT_NOTE_LINE_REQUEST, UPDATE_PAY_CUSTOMER_PAYMENT_NOTE_LINE_SUCCESS, UPDATE_PAY_CUSTOMER_PAYMENT_NOTE_LINE_ERROR, DELETE_PAY_CUSTOMER_PAYMENT_NOTE_LINE_REQUEST, DELETE_PAY_CUSTOMER_PAYMENT_NOTE_LINE_SUCCESS, DELETE_PAY_CUSTOMER_PAYMENT_NOTE_LINE_ERROR } from "./types";
import { BASEURL } from "../../constant/config.js";
const axios = require("axios");

export const addCustomerPaymentNoteLine = (token, object) => (dispatch) => {
    dispatch({ type: ADD_PAY_CUSTOMER_PAYMENT_NOTE_LINE_REQUEST });
    // let newData = {
    //     payment_header_id: headerID,
    //     obj
    // };
    return axios({
        method: "POST",
        url: `${BASEURL}create/payCustomerPaymentNote`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: object,
    })
        .then((response) => {
            return dispatch({
                type: ADD_PAY_CUSTOMER_PAYMENT_NOTE_LINE_SUCCESS,
                payload: response.data,
            });
        })
        .catch((error) => {
            return dispatch({
                type: ADD_PAY_CUSTOMER_PAYMENT_NOTE_LINE_ERROR,
                payload: error.response,
            });
        });
};

export const getOneCustomerPaymentNoteLine = (token, id) => (dispatch) => {
    dispatch({ type: GET_ONE_PAY_CUSTOMER_PAYMENT_NOTE_LINE_REQUEST });
    return axios({
        method: "GET",
        url: `${BASEURL}getOne/payCustomerPaymentNote/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
    })
        .then((response) => {
            return dispatch({
                type: GET_ONE_PAY_CUSTOMER_PAYMENT_NOTE_LINE_SUCCESS,
                payload: response.data,
            });
        })
        .catch((error) => {
            return dispatch({
                type: GET_ONE_PAY_CUSTOMER_PAYMENT_NOTE_LINE_ERROR,
                payload: error.response,
            });
        });
};

export const getCustomerPaymentNoteDetails = (token, customer_id) => (dispatch) => {
    dispatch({ type: GET_CUSTOMER_PAYMENT_DETAIL_REQUEST });
    let newData = {
        customer_id: customer_id,
    };
    return axios({
        method: "POST",
        url: `${BASEURL}getAll/payCustomerPaymentNote`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: newData,
    })
        .then((response) => {
            return dispatch({
                type: GET_CUSTOMER_PAYMENT_DETAIL_SUCCESS,
                payload: response.data,
            });
        })
        .catch((error) => {
            return dispatch({
                type: GET_CUSTOMER_PAYMENT_DETAIL_ERROR,
                payload: error.response,
            });
        });
};


export const updateCustomerPaymentNoteLine = (token, object, itemTransferId) => (dispatch) => {
    object.map((item) => {
        delete item.balance_amount;
        delete item.payment_header_id;
        delete item.invoice_amount;
        delete item.invoice_header_no;
        delete item.invoice_header_id;
        delete item.paid_amount;
        delete item.created_by;
        delete item.created_date;
        delete item.invoice_date;
        delete item.is_deleted;
        delete item.last_updated_by;
        delete item.last_updated_date;
        delete item.header
        return item;
    });
    dispatch({ type: UPDATE_PAY_CUSTOMER_PAYMENT_NOTE_LINE_REQUEST });
    return axios({
        method: "PUT",
        url: `${BASEURL}update/payCustomerPaymentNote/${itemTransferId}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: object,

    })
        .then((response) => {
            return dispatch({
                type: UPDATE_PAY_CUSTOMER_PAYMENT_NOTE_LINE_SUCCESS,
                payload: response?.data,
            });
        })
        .catch((error) => {
            return dispatch({
                type: UPDATE_PAY_CUSTOMER_PAYMENT_NOTE_LINE_ERROR,
                payload: error.response,
            });
        });
};


export const deleteCustomerPaymentNoteLine = (token, data, id) => (dispatch) => {
    dispatch({ type: DELETE_PAY_CUSTOMER_PAYMENT_NOTE_LINE_REQUEST });

    data.map((val) => {
        delete val.amount_applied;
        delete val.applied_to_transaction_id;
        delete val.applied_to_transaction_type;
        delete val.note_date;
        delete val.note_header_no;
        delete val.payment_header_id;
        delete val.remaining_amount;
    })
    return axios({
        method: "DELETE",
        url: `${BASEURL}delete/payCustomerPaymentNote/${id}`,
        headers: {
            Accept: "application/json",
            Authorization: "Bearer " + token,
        },
        data: { data: data }
    })
        .then((response) => {
            return dispatch({
                type: DELETE_PAY_CUSTOMER_PAYMENT_NOTE_LINE_SUCCESS,
                payload: response.data,
            });
        })
        .catch((error) => {
            return dispatch({
                type: DELETE_PAY_CUSTOMER_PAYMENT_NOTE_LINE_ERROR,
                payload: error.response,
            });
        });
};